import UserDetails from "../../../jsx/components/Dashboard/UserDetails/userdetails";

const UserDetailsWrapper = () => {
  return <UserDetails />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];
export default constore(UserDetailsWrapper);
